const metaTags = {
  home: {
    title: "<OrhanYilmaz/>",
    description: "Professioneller Front-End Entwickler mit Expertise in HTML, CSS, JavaScript und React. Benutzerfreundliche und innovative Weblösungen für Ihr Unternehmen.",
    keywords: "Front-End Entwickler, Web Designer, Responsive Design, Offenburg"
  },
  about: {
    title: "<OrhanYilmaz/>",
    description: "Erfahren Sie mehr über Orhan YILMAZ, seine Karriere und Expertise in der Webentwicklung. Spezialisiert auf moderne Frontend-Technologien.",
    keywords: "Über Orhan YILMAZ, Frontend Expertise, Web Development Background, Karriere"
  },
  services: {
    title: "<OrhanYilmaz/>",
    description: "Von Web-Design bis Full-Stack-Entwicklung: Entdecken Sie die professionellen Dienstleistungen von Orhan YILMAZ für Ihr Unternehmen.",
    keywords: "Web Design, Frontend Entwicklung, Full-Stack, UI/UX Design, Responsive Websites"
  },
  resume: {
    title: "<OrhanYilmaz/>",
    description: "Übersicht der Qualifikationen, Fähigkeiten und beruflichen Erfahrungen von Orhan YILMAZ im Bereich der Frontend-Entwicklung.",
    keywords: "CV, Lebenslauf, Berufserfahrung, Kompetenzen, Webentwicklung, Programmierung"
  },
  portfolio: {
    title: "<OrhanYilmaz/>",
    description: "Ausgewählte Webentwicklungsprojekte und Arbeiten von Orhan YILMAZ. Moderne Websites, Dashboards und Anwendungen.",
    keywords: "Webportfolio, Projekte, Webdesign Beispiele, Webentwicklung, Kundenarbeiten"
  },
  contact: {
    title: "<OrhanYilmaz/>",
    description: "Nehmen Sie Kontakt mit Orhan YILMAZ auf für Ihre Webentwicklungsprojekte oder bei Fragen zu seinen Dienstleistungen.",
    keywords: "Kontakt, Webentwicklung Anfrage, Projektanfrage, E-Mail, Zusammenarbeit"
  }
};

export default metaTags; 